import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ReimbursementsListPage from './ReimbursementsListPage';

export default function ReimbursementsRoutes() {
  return (
    <Routes>
      <Route index element={<ReimbursementsListPage />} />
    </Routes>
  );
}
